import PropTypes from 'prop-types'

import styled from 'styled-components'

import LoadingIndicator from 'components/Shared/LoadingIndicator/Index'
import TicketFilter from './TicketFilter'

const StyledWrapper = styled.div`
  position: relative;
`

const TicketFiltersList = ({
  ticketFilters, activeTicketFilterIds, onEditFilter,
  onDeleteFilter, onToggleFilter, editingFilter, isTicketFiltersFetching,
}) => {
  return (
    <StyledWrapper>
      <LoadingIndicator loading={isTicketFiltersFetching} small />
      {ticketFilters.map(filter =>
        <TicketFilter
          key={filter.id}
          filter={filter}
          activeTicketFilterIds={activeTicketFilterIds}
          onToggle={onToggleFilter}
          onEdit={onEditFilter}
          onDelete={onDeleteFilter}
          isEditing={editingFilter?.id === filter.id}
        />
      )}
    </StyledWrapper>
  )
}

TicketFiltersList.propTypes = {
  ticketFilters: PropTypes.array.isRequired,
  activeTicketFilterIds: PropTypes.array.isRequired,
  onEditFilter: PropTypes.func.isRequired,
  onDeleteFilter: PropTypes.func.isRequired,
  onToggleFilter: PropTypes.func.isRequired,
  editingFilter: PropTypes.object,
  isTicketFiltersFetching: PropTypes.bool,
}

export default TicketFiltersList
